export default __webpack_public_path__ + "static/media/538.d4daf693.jpg";